import { useLocalStorage } from '@mint-lib/hooks';
import { useTranslation } from '@mint-lib/i18n';
import { Alert } from '@mint-lib/tw-components/patterns';

import { useDataFileContext } from '../../contexts/DataFileContext/useDataFileContext.js';

export const CutFooterRowsAlert = () => {
  const { dataFilePreview } = useDataFileContext();
  const { t } = useTranslation('@myn/import-hub');
  const [isDismissed, setIsDismissed] = useLocalStorage(
    '@myn/import-hub.cutFooterRowsAlertDismissed',
    { initialValue: false },
  );

  const isFooterRowSelected = Boolean(dataFilePreview.footerRowsCount);

  if (!isFooterRowSelected || isDismissed) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      variant="inline"
      title={t('Cascade selection active.')}
      description={t(
        'The selected row(s) in the file footer will be automatically discarded during import.',
      )}
      removable={true}
      onClose={() => setIsDismissed(true)}
      className="mb-3"
    />
  );
};
